module.exports = __webpack_public_path__ + "Flag-768.63cdf8ff09aef1263da96031bf799e2b.svg";